module.exports = __webpack_public_path__ + "img/about_img06.91d2b111.png";